const API = 'https://lmsa.ecoworldsales.com/lms/public/v1/lead/new/duduk';
const TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjkwNTIzZTg0LWFjZWUtNDljMS05NmJlLWNkZmZlMmQzZjE4ZCIsInVzZXJuYW1lIjoibWlzLWR1ZHVrIiwicm9sZV9uYW1lIjoiUk9MRV9TQUxFU19SRVAiLCJpYXQiOjE1OTE3ODQ0NzR9.IOi6Gxeo59ZOdP-cb88IYEBK-i9aFEQwlznbm31TYEU';
const CONFIG = {
    headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json'
    },
};

export { API, TOKEN, CONFIG };